import { tv, type VariantProps } from 'tailwind-variants';

export const articleHeader = tv(
  {
    defaultVariants: {
      layout: 'default',
    },
    slots: {
      articleDate: 'text-secondary typography-xs',
      authorByline: 'flex flex-col min-w-0 typography-sm gap-sm',
      authorLink: 'font-medium capitalize typography-sm',
      authorRole: 'text-secondary typography-xs capitalize',
      bylineCommentary: 'typography-xs mr-[10px] italic font-graphik-compact',
      bylineWrapper: 'flex w-full justify-between items-start font-graphik gap-sm',
      contentWrapper: 'flex flex-col w-full self-start grow-1 gap-xl',
      contributorCard: 'stroke-inverse border-t-4 bg-pure mt-2 shadow-[0px_4px_20px_0px_rgba(0,0,0,0.08)] rounded-sm',
      excerpt: 'typography-level-5 w-fit text-secondary',
      eyebrow: 'uppercase hover:underline typography-sm font-medium text-secondary',
      eyebrowDot: 'font-medium mb-1 icon-red!',
      eyebrowWrapper: 'ml-[3px] flex items-center flex-wrap tracking-wider font-graphik',
      heroHeaderWrapper: 'flex flex-col gap-lg',
      heroWrapper: 'flex flex-col lg:flex-row items-center w-full flex-nowrap col-span-3',
      image: 'w-full h-auto',
      media: 'w-full h-full grow-1 gap-xs',
      mediaMeta: 'flex h-fit w-fit flex-col max-lg:layout-safe-area',
      miscContent: 'container-content w-full flex flex-col items-center justify-center layout-gap-md',
      miscWrapper: 'flex flex-col items-center w-full col-start-2',
      socials: 'w-fit -mr-[10px] md:mr-0',
      title: 'font-bold font-inria-serif typography-level-1',
      wrapper: 'contents',
    },
    variants: {
      layout: {
        default: {
          contentWrapper: 'max-lg:container-ft',
          heroWrapper: 'layout-grid-gap',
        },
        defaultEducation: {
          contentWrapper: 'max-lg:container-ft',
          heroWrapper: 'layout-grid-gap col-span-2',
          media: 'col-start-1 col-span-2',
        },
        //biome-ignore lint/style/useNamingConvention: Not sure @Daniel
        ez_newswire: {
          wrapper: 'flex flex-col gap-10 col-span-2',
        },
        features: {
          contentWrapper:
            'flex flex-col items-center justify-center h-full max-md:container-ft md:px-12 py-12 md:py-6 relative z-body-popover max-md:order-2',
          excerpt: 'self-center hidden lg:block text-center',
          eyebrowWrapper: 'justify-center',
          heroWrapper: 'md:grid md:grid-cols-2 relative md:max-lg:container-ft',
          image: 'max-md:sticky top-0 h-full',
          mediaMeta: 'self-start',
          title: 'text-center',
        },
        landing: {},
      },
    },
  },
  {
    twMerge: true,
  },
);

export type ArticleHeaderVariants = VariantProps<typeof articleHeader>;
